import * as React from 'react';
import { ISharedJourneyItem } from '../../helpers';
import { Search } from '../common/search';
import { Button, ButtonType } from 'office-ui-fabric-react';

interface IProps {
	componentId: string;
	journeyId: string;
	journeyName: string;
	setSharedJourney: (componentId: string, journeyId: string) => void;
	updateSearchResults: (searchTerm: string) => void;
	onSearchBlur: () => void;
	sharedJourneyResults: ISharedJourneyItem[];
	sharedJourneyTerm: string;
}

export class SharedJourneySearch extends React.Component<IProps, any> {

	public render() {

		let { componentId, journeyId, journeyName, setSharedJourney, sharedJourneyResults, sharedJourneyTerm, onSearchBlur, updateSearchResults } = this.props;

		return (

			journeyId && journeyId.length ? 
				<div className='ms-TextField shared-journey'>
					<div className='ms-TextField-field'>{ journeyName }
						<Button
							buttonType={ ButtonType.icon }
							icon='Cancel'
							onClick={ 
								() => {
									setSharedJourney(componentId, '');
								}
							}
						/>
					</div>
				</div>
			:	<Search 
					results={ sharedJourneyResults }
					searchTerm={ sharedJourneyTerm }
					labelText={ 'Search for a shared journey' }
					showResultsWithEmptyTerm={ false }
					isCurrentSearchComponent={ true }
					awaitingResults={ false }
					debounceDelay={ 250 }
					displaySharedJourneyItems={ true }
					onResultClick={ (key, item) => {
						setSharedJourney(componentId, key);
					} }
					onBlur={ onSearchBlur }
					updateResults={ updateSearchResults }
				/>
		);

	}

}


// WEBPACK FOOTER //
// ./source/ts/components/shared-journey/shared-journey-search.tsx